import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, List, ModalHeader, Typography } from 'common/components';
import { css } from 'linaria';
import {
  BATHROOM_REPAIR_ELEMENT_BLOCK,
  BATHROOM_REPAIR_SIGN_UP_HREF,
} from '../../../../bathroom-repair-constants';

const modalText = css`
  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

const modalListItem = css`
  && {
    && {
      margin-bottom: 8px;
    }
  }
`;

type GuaranteeProps = {
  regionId: string;
};

export const GuaranteeModal = ({ regionId }: GuaranteeProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader title={t('utp-section.guarantee.card-title')} />
      <ModalContent>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.guarantee.modal-description-first')}
        </Typography>
        <Typography variant="h2" className={modalText}>
          {t('utp-section.guarantee.modal-title-second')}
        </Typography>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.guarantee.modal-description-second')}
        </Typography>
        <List listStyle="disc">
          <li className={modalListItem}>
            <Typography variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-first')}
            </Typography>
          </li>
          <li className={modalListItem}>
            <Typography variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-second')}
            </Typography>
          </li>
        </List>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.guarantee.modal-description-third')}
        </Typography>
      </ModalContent>
      <ModalFooter>
        <ButtonWithGAClickButton
          adaptive={false}
          elementBlock={BATHROOM_REPAIR_ELEMENT_BLOCK}
          elementName={`${t('utp-section.guarantee.card-title')} / modal`}
          elementText={t('utp-section.modal-button')}
          href={`${BATHROOM_REPAIR_SIGN_UP_HREF}${regionId}`}
          target="_blank"
          wide>
          {t('utp-section.modal-button')}
        </ButtonWithGAClickButton>
      </ModalFooter>
    </>
  );
};
